import React, { useState } from 'react';

const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '642040136241';

const offerings = [
  {
    title: 'Make sense of your data',
    body: 'I can analyse and take meaning out of your data — sales, bookings, clients, jobs. Data entry, cleanup, visualisations, statistical analysis, predictions, root cause analysis, reports. Pulled out of messy spreadsheets and into something that tells you what\'s actually going on.',
    icon: '📊',
  },
  {
    title: 'Implementing AI to your workflow?',
    body: 'Have you thought about how AI could improve the way you work? I use it daily in my own workflow, I\'m an active participant of AI Forum NZ and the Christchurch AI community. Let\'s talk how to integrate it into your business — and show you how to drive it yourself.',
    icon: '🤖',
  },
  {
    title: 'Clear the admin backlog',
    body: 'Inbox management, calendar and appointment management, supplier follow-ups, document organisation. By the hour, or as a small monthly arrangement.',
    icon: '📋',
  },
  {
    title: 'Website work',
    body: 'An honest audit of your current site — what\'s working, what\'s costing you, what to fix first. Or creating you something new. Improving what\'s already there. Governance too, if you need it.',
    icon: '🌐',
  },
  {
    title: 'Health & safety and hazardous substances',
    body: 'Years of experience in chemical safety, fluid analysis, and regulatory frameworks. Useful for any business handling product chemicals.',
    icon: '🔬',
  },
];

const inputBase = {
  width: '100%',
  border: '0.5px solid #C8D8C0',
  borderRadius: '8px',
  padding: '0.75rem',
  fontFamily: "'DM Sans', sans-serif",
  fontSize: '0.9rem',
  color: '#1A1530',
  outline: 'none',
  background: '#fff',
  boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};

export default function BusinessSupport() {
  const [name, setName] = useState('');
  const [help, setHelp] = useState('');
  const [phone, setPhone] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    const msg = encodeURIComponent(
      `Hi! I'd love to chat about business support.\nName: ${name}\nWhat I'm juggling: ${help}\nMy WhatsApp: ${phone}`
    );
    window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, '_blank', 'noopener,noreferrer');
  }

  function focusBorder(e) {
    e.target.style.borderColor = '#3A5A48';
  }
  function blurBorder(e) {
    e.target.style.borderColor = '#C8D8C0';
  }

  return (
    <section
      id="business-support"
      style={{
        background: 'linear-gradient(160deg, #F2F8F4 0%, #E8F0EC 100%)',
        padding: '3.5rem 0',
        borderTop: '2px solid #C8D8C0',
      }}
    >
      <div className="content-column">
        <div className="section-tag" style={{ color: '#5A7A68' }}>Business support</div>
        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
          fontSize: '1.75rem',
          lineHeight: 1.25,
          color: '#1A1530',
          marginTop: 0,
          marginBottom: '1rem',
        }}>
          Running a small{' '}
          <em style={{ fontWeight: 400, color: '#3A5A48' }}>business?</em>
        </h2>

        <p style={{
          fontSize: '0.93rem',
          fontWeight: 300,
          color: '#6A6080',
          lineHeight: 1.7,
          marginTop: 0,
          marginBottom: '0.75rem',
          maxWidth: '580px',
        }}>
          I'm an engineer and analyst transitioning into full-stack development. While I do that, I'm offering hands-on business support — and I'd genuinely love to put my background to work for the people in my own community.
        </p>

        <p style={{
          fontSize: '0.93rem',
          fontWeight: 300,
          color: '#6A6080',
          lineHeight: 1.7,
          marginTop: 0,
          marginBottom: '1.75rem',
          maxWidth: '580px',
        }}>
          If you're running a small business — chances are you're doing five jobs at once and falling behind on the one that actually matters. Let's talk about how I can free up your headspace.
        </p>

        {/* Offerings */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem', marginBottom: '1.75rem' }}>
          {offerings.map((item) => (
            <div key={item.title} style={{
              background: '#fff',
              border: '0.5px solid #C8D8C0',
              borderRadius: '1rem',
              padding: '1.25rem',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.5rem' }}>
                <span style={{ fontSize: '1.2rem' }}>{item.icon}</span>
                <div style={{
                  fontWeight: 600,
                  fontSize: '0.93rem',
                  color: '#1A1530',
                }}>
                  {item.title}
                </div>
              </div>
              <p style={{
                fontSize: '0.85rem',
                fontWeight: 300,
                color: '#6A6080',
                lineHeight: 1.65,
                margin: 0,
              }}>
                {item.body}
              </p>
            </div>
          ))}
        </div>

        {/* Credentials */}
        <div style={{
          background: 'rgba(255,255,255,0.6)',
          border: '0.5px solid #C8D8C0',
          borderRadius: '1rem',
          padding: '1.25rem',
          marginBottom: '1.75rem',
          fontSize: '0.83rem',
          fontWeight: 300,
          color: '#11042f',
          lineHeight: 1.65,
        }}>
          <div style={{ fontWeight: 600, color: '#1A1530', marginBottom: '0.4rem', fontSize: '0.85rem' }}>
            About me, professionally
          </div>
          Engineer with around nine years of industrial experience across analytical chemistry, biotech and data analytics — Active member of Engineering New Zealand and the Christchurch/NZ AI community.
        </div>

        {/* CTA */}
        <div style={{
          background: 'linear-gradient(135deg, #3A5A48 0%, #2A4A38 100%)',
          borderRadius: '1.25rem',
          padding: '1.5rem',
          marginBottom: '1.25rem',
        }}>
          <div style={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 600,
            fontSize: '1.15rem',
            color: '#fff',
            marginBottom: '0.6rem',
          }}>
            Let's have a 30-minute chat
          </div>
          <p style={{
            fontSize: '0.88rem',
            fontWeight: 300,
            color: '#C8E0D0',
            lineHeight: 1.65,
            marginTop: 0,
            marginBottom: '0.5rem',
          }}>
            No commitment, I love learning about what other local businesses are up to. We'll dive into your analytics, talk through your goals, and brainstorm the best steps to help you move forward.
          </p>
          <p style={{
            fontSize: '0.82rem',
            fontWeight: 300,
            fontStyle: 'italic',
            color: '#A8C8B0',
            lineHeight: 1.5,
            margin: 0,
          }}>
            Pricing quoted on enquiry — depends on scope, and I'd rather have a real conversation than throw a number at you cold.
          </p>
        </div>

        {/* Contact form */}
        <div style={{
          background: '#fff',
          border: '0.5px solid #C8D8C0',
          borderRadius: '1.25rem',
          padding: '1.5rem',
          maxWidth: '560px',
        }}>
          <div style={{
            fontWeight: 600,
            fontSize: '0.9rem',
            color: '#1A1530',
            marginBottom: '1rem',
          }}>
            Tell me a bit about what you're juggling
          </div>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
            <input
              type="text"
              placeholder="Your name"
              value={name}
              onChange={e => setName(e.target.value)}
              style={inputBase}
              onFocus={focusBorder}
              onBlur={blurBorder}
              required
            />
            <textarea
              placeholder="Data analysis, reports, inbox management, website, something else entirely... whatever's taking up your time"
              value={help}
              onChange={e => setHelp(e.target.value)}
              rows={4}
              style={{ ...inputBase, resize: 'vertical' }}
              onFocus={focusBorder}
              onBlur={blurBorder}
              required
            />
            <input
              type="tel"
              placeholder="+64 ..."
              value={phone}
              onChange={e => setPhone(e.target.value)}
              style={inputBase}
              onFocus={focusBorder}
              onBlur={blurBorder}
              required
            />
            <button
              type="submit"
              style={{
                background: '#3A5A48',
                color: '#fff',
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 600,
                fontSize: '0.97rem',
                padding: '0.85rem 1.75rem',
                borderRadius: '2rem',
                border: 'none',
                cursor: 'pointer',
                width: '100%',
                transition: 'opacity 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.opacity = '0.9'; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
            >
              Let's figure it out →
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
